import React from 'react';
import { useAppDispatch, useAppSelector } from '../ducks/hooks';
import { Button, Dialog, FirstRunExperience, FirstRunExperienceItem } from '../providers/harmony-scope/lazy-enablers';
import { clearAllSplashScreenNotifications } from '../ducks/splash-screen-notifications/duck-splash-screen-notifications';
import { useMEMTranslation } from '../utils/text-utils';
import RichTextRender from './rich-text-editor/rich-text-render';
import { buildSharePointEmbedUrl } from '../utils/notification-utils';

export const SplashScreenNotificationsContainer = () => {
  const { t } = useMEMTranslation();
  const notifications = useAppSelector((state) => state.splashScreenNotifications.notifications);
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(clearAllSplashScreenNotifications());
  };

  return (
    <Dialog open={notifications.length > 0} noHeader style={{ '--width': '700px', '--body-padding': '0px' }} onHeDialogAfterHide={handleClose}>
      <FirstRunExperience autofocus>
        {notifications.map((notification, index) => {
          const isFirst = index === 0;
          const isLast = index === notifications.length - 1;
          const hasMedia = notification.sharePointMedia?.teamName && notification.sharePointMedia?.uniqueId;
          const mediaUrl = hasMedia ? buildSharePointEmbedUrl(notification.sharePointMedia!) : undefined;

          return (
            <FirstRunExperienceItem key={notification.notificationReferenceId} heading={notification.title}>
              {hasMedia && mediaUrl && (
                <div slot="media">
                  <iframe src={mediaUrl} width="700" height="394" frameBorder="0" scrolling="no" allowFullScreen title={notification.title}></iframe>
                  <a href={mediaUrl} target="_blank" rel="noreferrer" style={{ marginLeft: '10px' }}>
                    {t('splashScreenOpenMediaNewWindow')}
                  </a>
                </div>
              )}
              <RichTextRender delta={notification.richMessage || ''} />
              {!isFirst && <Button slot="footer-start">{t('splashScreenBack')}</Button>}
              {!isLast && (
                <Button slot="footer-end" appearance="primary">
                  {t('splashScreenNext')}
                </Button>
              )}
              {isLast && (
                <Button slot="footer-end" appearance="primary" onClick={handleClose}>
                  {t('splashScreenClose')}
                </Button>
              )}
            </FirstRunExperienceItem>
          );
        })}
      </FirstRunExperience>
    </Dialog>
  );
};
